import * as GraphqlImporter from './graphql-importer'
import commonRequestApi from '../../request'
import Response from '../../Response'
import { DocumentNode } from 'graphql'

export const SERVER_URL = '/web/gql/Resourcetag-Default'

// 枚举

// 类

export class Page {
  pageNo?: number
  pageSize?: number
}

/**
 * 试题标签新增dto
@author yeyc create 2020/11/17 10:54
 */
export class ResourceTagAddRequest {
  /**
   * 标签名称
   */
  name?: string
  /**
   * 标签分类id
   */
  categoryId?: string
}

/**
 * 标签分类新增对象
@author yeyc create 2020/11/17 11:02
 */
export class ResourceTagCategoryAddRequest {
  /**
   * 标签分类名称
   */
  name?: string
}

/**
 * 标签分类更新对象
@author yeyc create 2020/11/17 11:02
 */
export class ResourceTagCategoryUpdateRequest {
  /**
   * 标签分类更新id
   */
  id?: string
  /**
   * 标签分类名称
   */
  name?: string
}

/**
 * 标签查询信息
 */
export class ResourceTagQueryRequest {
  /**
   * 分类ID
   */
  categoryId?: string
}

/**
 * 标签更新
@author yeyc create 2020/11/17 10:58
 */
export class ResourceTagUpdateRequest {
  /**
   * 标签id
   */
  id?: string
  /**
   * 标签名称
   */
  name?: string
  /**
   * 标签分类id
   */
  categoryId?: string
}

export class MajorDto {
  relationId: string
  name: string
  id: string
}

/**
 * 版权来源
@author yeyc create 2020/11/26 13:58
 */
export class CopyrightResponse {
  /**
   * id
   */
  id: string
  /**
   * 版权来源
   */
  copyright: string
  /**
   * 标签代码
   */
  code: string
}

/**
 * 行业专业关系对象
@author yeyc create 2020/11/25 15:36
 */
export class IndustryRelationResponse {
  /**
   * 行业关系id
   */
  relationId: string
  /**
   * 行业名称
   */
  name: string
  /**
   * 行业id
   */
  id: string
  /**
   * 该行业下专业集合
   */
  majorList: Array<MajorResponse>
}

/**
 * 专业
@author yeyc create 2020/11/25 15:39
 */
export class MajorResponse {
  /**
   * 专业关系id
   */
  relationId: string
  /**
   * 专业名称
   */
  name: string
  /**
   * 专业id
   */
  id: string
}

/**
 * 地区对象
@author yeyc create 2020/11/26 14:50
 */
export class RegionResponse {
  /**
   * 地区id
   */
  id: string
  /**
   * 地区名称
   */
  name: string
  /**
   * 地区关系id
   */
  relationId: string
}

/**
 * 标签分类
@author yeyc create 2020/11/17 11:02
 */
export class ResourceTagCategoryResponse {
  /**
   * 标签分类id
   */
  id: string
  /**
   * 标签分类名称
   */
  name: string
}

/**
 * 试题标签对象
@author yeyc create 2020/11/17 10:43
 */
export class ResourceTagResponse {
  /**
   * 标签id
   */
  id: string
  /**
   * 标签名称
   */
  name: string
  /**
   * 标签分类id
   */
  categoryId: string
  /**
   * 标签代码
   */
  code: string
}

/**
 * 年度
@author yeyc create 2020/11/26 13:53
 */
export class YearResponse {
  /**
   * 年度id
   */
  id: string
  /**
   * 年度
   */
  year: string
}

export class ResourceTagCategoryResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<ResourceTagCategoryResponse>
}

export class CopyrightResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<CopyrightResponse>
}

export class ResourceTagResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<ResourceTagResponse>
}

export class YearResponsePage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<YearResponse>
}

class DataGateway {
  async _commonQuery<T>(query: DocumentNode, params?: unknown, operation?: string): Promise<Response<T>> {
    return commonRequestApi<T>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 查询名称是否存在
   * @param regionId id存在时忽略本身
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async checkExistName(
    params: { regionId?: string; name?: string },
    query: DocumentNode = GraphqlImporter.checkExistName,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 根据上级关系id 查询专业
   * @param relationId
   * @return
   * @param query 查询 graphql 语法文档
   * @param relationId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findMajorRelationByRelationId(
    relationId: string,
    query: DocumentNode = GraphqlImporter.findMajorRelationByRelationId,
    operation?: string
  ): Promise<Response<Array<MajorDto>>> {
    return commonRequestApi<Array<MajorDto>>(SERVER_URL, {
      query: query,
      variables: { relationId },
      operation: operation
    })
  }

  /**   * 根据关系id查询下级地区集合
   * @param relationId
   * @return
   * @param query 查询 graphql 语法文档
   * @param relationId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findSubordinateByRelationId(
    relationId: string,
    query: DocumentNode = GraphqlImporter.findSubordinateByRelationId,
    operation?: string
  ): Promise<Response<Array<RegionResponse>>> {
    return commonRequestApi<Array<RegionResponse>>(SERVER_URL, {
      query: query,
      variables: { relationId },
      operation: operation
    })
  }

  /**   * 获取试题标签分类信息
   * @param id
   * @return
   * @param query 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getCategory(
    id: string,
    query: DocumentNode = GraphqlImporter.getCategory,
    operation?: string
  ): Promise<Response<ResourceTagCategoryResponse>> {
    return commonRequestApi<ResourceTagCategoryResponse>(SERVER_URL, {
      query: query,
      variables: { id },
      operation: operation
    })
  }

  /**   * 根据id集合查询分类
   * @param idList
   * @return
   * @param query 查询 graphql 语法文档
   * @param idList 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getCategoryList(
    idList: Array<string>,
    query: DocumentNode = GraphqlImporter.getCategoryList,
    operation?: string
  ): Promise<Response<Array<ResourceTagCategoryResponse>>> {
    return commonRequestApi<Array<ResourceTagCategoryResponse>>(SERVER_URL, {
      query: query,
      variables: { idList },
      operation: operation
    })
  }

  /**   * 根据id 查询标签
   * @param id
   * @return
   * @param query 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getResourceTag(
    id: string,
    query: DocumentNode = GraphqlImporter.getResourceTag,
    operation?: string
  ): Promise<Response<ResourceTagResponse>> {
    return commonRequestApi<ResourceTagResponse>(SERVER_URL, {
      query: query,
      variables: { id },
      operation: operation
    })
  }

  /**   * 查询行业专业关系集合
   * @param page
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listIndustryRelation(
    query: DocumentNode = GraphqlImporter.listIndustryRelation,
    operation?: string
  ): Promise<Response<Array<IndustryRelationResponse>>> {
    return commonRequestApi<Array<IndustryRelationResponse>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 查询标签分类集合
   * @param query 查询 graphql 语法文档
   * @param page 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageCategory(
    page: Page,
    query: DocumentNode = GraphqlImporter.pageCategory,
    operation?: string
  ): Promise<Response<ResourceTagCategoryResponsePage>> {
    return commonRequestApi<ResourceTagCategoryResponsePage>(SERVER_URL, {
      query: query,
      variables: { page },
      operation: operation
    })
  }

  /**   * 分页获取所有年度
   * @return
   * @param query 查询 graphql 语法文档
   * @param page 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageCopyright(
    page: Page,
    query: DocumentNode = GraphqlImporter.pageCopyright,
    operation?: string
  ): Promise<Response<CopyrightResponsePage>> {
    return commonRequestApi<CopyrightResponsePage>(SERVER_URL, {
      query: query,
      variables: { page },
      operation: operation
    })
  }

  /**   * 分页查询试题标签
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageResourceTag(
    params: { page?: Page; query?: ResourceTagQueryRequest },
    query: DocumentNode = GraphqlImporter.pageResourceTag,
    operation?: string
  ): Promise<Response<ResourceTagResponsePage>> {
    return commonRequestApi<ResourceTagResponsePage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 分页获取所有年度
   * @return
   * @param query 查询 graphql 语法文档
   * @param page 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageYear(
    page: Page,
    query: DocumentNode = GraphqlImporter.pageYear,
    operation?: string
  ): Promise<Response<YearResponsePage>> {
    return commonRequestApi<YearResponsePage>(SERVER_URL, {
      query: query,
      variables: { page },
      operation: operation
    })
  }

  /**   * 新增试题标签分类
   * @param addDto
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param addRequest 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async addCategory(
    addRequest: ResourceTagCategoryAddRequest,
    mutate: DocumentNode = GraphqlImporter.addCategory,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { addRequest },
      operation: operation
    })
  }

  /**   * 添加版权来源
   * @param mutate 查询 graphql 语法文档
   * @param name 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async addCopyright(
    name: string,
    mutate: DocumentNode = GraphqlImporter.addCopyright,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { name },
      operation: operation
    })
  }

  /**   * 增加行业专业关系
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async addIndustryRelation(
    params: { industryName?: string; majorName?: string },
    mutate: DocumentNode = GraphqlImporter.addIndustryRelation,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 新增专业
   * @param relationId 行业的关系id
   * @param majorName  专业名称
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async addMajor(
    params: { relationId?: string; majorName?: string },
    mutate: DocumentNode = GraphqlImporter.addMajor,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 添加一级地区属性
   * @param relationId 为空时默认创建第一级节点，关系节点id。
   * @param name
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async addRegion(
    params: { relationId?: string; name?: string },
    mutate: DocumentNode = GraphqlImporter.addRegion,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 新增标签
   * @param add
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param add 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async addResourceTag(
    add: ResourceTagAddRequest,
    mutate: DocumentNode = GraphqlImporter.addResourceTag,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { add },
      operation: operation
    })
  }

  /**   * 添加年度来源
   * @param mutate 查询 graphql 语法文档
   * @param year 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async addYear(
    year: string,
    mutate: DocumentNode = GraphqlImporter.addYear,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { year },
      operation: operation
    })
  }

  /**   * 检测版权名称
   * @param name
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async checkCopyright(
    params: { id?: string; name?: string },
    mutate: DocumentNode = GraphqlImporter.checkCopyright,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 检测年度名称
   * @param name
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async checkYear(
    params: { id?: string; year?: string },
    mutate: DocumentNode = GraphqlImporter.checkYear,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 检测行业名称
   * @param name
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async existIndustryName(
    params: { industryRelationId?: string; name?: string },
    mutate: DocumentNode = GraphqlImporter.existIndustryName,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 检测专业名称
   * @param name
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async existMajorName(
    params: { majorRelationId?: string; name?: string },
    mutate: DocumentNode = GraphqlImporter.existMajorName,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 查询地区集合
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findRegionList(
    mutate: DocumentNode = GraphqlImporter.findRegionList,
    operation?: string
  ): Promise<Response<Array<RegionResponse>>> {
    return commonRequestApi<Array<RegionResponse>>(SERVER_URL, {
      query: mutate,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 校验名称是否存在
   * 若传了id 则会忽略掉自己本身
   * @param id
   * @param name
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async nameExist(
    params: { id?: string; name?: string },
    mutate: DocumentNode = GraphqlImporter.nameExist,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 移除试题标签分类
   * @param id
   * @param mutate 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeCategory(
    id: string,
    mutate: DocumentNode = GraphqlImporter.removeCategory,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { id },
      operation: operation
    })
  }

  /**   * 移除版权来源
   * @param mutate 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeCopyright(
    id: string,
    mutate: DocumentNode = GraphqlImporter.removeCopyright,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { id },
      operation: operation
    })
  }

  /**   * 移除行业
   * @param id
   * @param mutate 查询 graphql 语法文档
   * @param industryRelationId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeIndustry(
    industryRelationId: string,
    mutate: DocumentNode = GraphqlImporter.removeIndustry,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { industryRelationId },
      operation: operation
    })
  }

  /**   * 移除专业
   * @param id
   * @param mutate 查询 graphql 语法文档
   * @param majorRelationId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeMajor(
    majorRelationId: string,
    mutate: DocumentNode = GraphqlImporter.removeMajor,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { majorRelationId },
      operation: operation
    })
  }

  /**   * 删除地区属性
   * @param mutate 查询 graphql 语法文档
   * @param relationId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeRegion(
    relationId: string,
    mutate: DocumentNode = GraphqlImporter.removeRegion,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { relationId },
      operation: operation
    })
  }

  /**   * 删除标签
   * @param id
   * @param mutate 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeResourceTag(
    id: string,
    mutate: DocumentNode = GraphqlImporter.removeResourceTag,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { id },
      operation: operation
    })
  }

  /**   * 移除年度来源
   * @param mutate 查询 graphql 语法文档
   * @param id 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async removeYear(
    id: string,
    mutate: DocumentNode = GraphqlImporter.removeYear,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: { id },
      operation: operation
    })
  }

  /**   * 更新试题标签分类
   * @param updateDto
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param updateDto 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateCategory(
    updateDto: ResourceTagCategoryUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateCategory,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { updateDto },
      operation: operation
    })
  }

  /**   * 修改版权来源
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateCopyright(
    params: { id?: string; name?: string },
    mutate: DocumentNode = GraphqlImporter.updateCopyright,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 更新行业
   * @param relationId
   * @param industryName
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateIndustry(
    params: { relationId?: string; industryName?: string },
    mutate: DocumentNode = GraphqlImporter.updateIndustry,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 更新专业
   * @param majorId
   * @param majorName
   * @param mutate 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateMajor(
    params: { majorRelationId?: string; majorName?: string },
    mutate: DocumentNode = GraphqlImporter.updateMajor,
    operation?: string
  ): Promise<Response<void>> {
    return commonRequestApi<void>(SERVER_URL, {
      query: mutate,
      variables: params,
      operation: operation
    })
  }

  /**   * 更新标签
   * @param updateDto
   * @return
   * @param mutate 查询 graphql 语法文档
   * @param updateDto 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async updateResourceTag(
    updateDto: ResourceTagUpdateRequest,
    mutate: DocumentNode = GraphqlImporter.updateResourceTag,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: mutate,
      variables: { updateDto },
      operation: operation
    })
  }
}

export default new DataGateway()
